/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ValidationErrorResult2
 */
export interface ValidationErrorResult2 {
    /**
     * 
     * @type {ResultStates}
     * @memberof ValidationErrorResult2
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult2
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ValidationErrorResult2
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult2
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ValidationErrorResult2
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ValidationErrorResult2
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationErrorResult2
     */
    validationErrors: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the ValidationErrorResult2 interface.
 */
export function instanceOfValidationErrorResult2(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;

    return isInstance;
}

export function ValidationErrorResult2FromJSON(json: any): ValidationErrorResult2 {
    return ValidationErrorResult2FromJSONTyped(json, false);
}

export function ValidationErrorResult2FromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidationErrorResult2 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
    };
}

export function ValidationErrorResult2ToJSON(value?: ValidationErrorResult2 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
    };
}

